import { Directive } from '@angular/core';
import { CdkCellDef } from '@angular/cdk/table';

@Directive({
  selector: '[mcraiCellDef]',
  providers: [{ provide: CdkCellDef, useExisting: CellDefDirective }]
})
export class CellDefDirective extends CdkCellDef { }
